module.exports = __webpack_public_path__ + "img/productionBaseL.96a508de.png";